import React from 'react';
import { faqs } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQsPage = () => {
  return (
    <div>
      {/* Header */}
      <section className="section-padding-small">
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Frequently Asked Questions
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px' }}>
            Find answers to common questions about hypnotherapy, our services, and what to expect. If you don't see your question here, feel free to contact us.
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section style={{ paddingBottom: '120px' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} style={{
                  borderBottom: '1px solid var(--border-light)',
                  padding: '8px 0'
                }}>
                  <AccordionTrigger style={{
                    fontSize: '16px',
                    fontFamily: "'Cormorant Garamond', serif",
                    color: 'var(--text-primary)',
                    fontWeight: 500,
                    textAlign: 'left'
                  }}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent style={{
                    fontSize: '14px',
                    color: 'var(--text-secondary)',
                    lineHeight: '1.7',
                    paddingTop: '12px',
                    paddingBottom: '12px'
                  }}>
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQsPage;
